import React from 'react';
import { Gift, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'Guiones de WhatsApp para Tus Primeras Consultas',
  value: 8000
}, {
  title: 'Calculadora de Comisiones y Proyección de Ingresos PRO',
  value: 9000
}, {
  title: 'Biblioteca de Prompts para Arrancar Rápido con IA',
  value: 8000
}, {
  title: 'Plantillas de Mail Profesional para tu Primera Impresión',
  value: 10000
}];
export function BonusStack() {
  return <section className="py-20 bg-brand-lighter px-6 lg:px-8" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <div className="text-center mb-12" data-id="element-19">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-green/10 mb-6" data-id="element-20">
            <Gift className="w-8 h-8 text-brand-green" data-id="element-21" />
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-navy mb-4" data-id="element-22">
            Bonos de Acción Rápida
          </h2>
          <p className="text-xl text-brand-navy/70" data-id="element-23">
            Llevate todo esto{' '}
            <span className="font-bold text-brand-green" data-id="element-24">GRATIS</span> al
            ingresar hoy.
          </p>
        </div>

        <div className="space-y-4 mb-12" data-id="element-25">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 shadow-soft border border-brand-light" data-id="element-26">
              <div className="flex items-start gap-4" data-id="element-27">
                <CheckCircle2 className="w-6 h-6 text-brand-green shrink-0 mt-1 sm:mt-0" data-id="element-28" />
                <h4 className="text-lg font-bold text-brand-navy" data-id="element-29">
                  {bonus.title}
                </h4>
              </div>
              <div className="flex items-center gap-2 shrink-0" data-id="element-30">
                <span className="inline-flex items-center gap-1 text-brand-gold/90 text-xs font-bold uppercase tracking-wide border border-brand-gold/40 rounded-full px-3 py-1" data-id="element-31">
                  Valorado en ${bonus.value.toLocaleString('es-AR')}
                </span>
                <span className="text-brand-navy/30 font-bold" data-id="element-32">→</span>
                <span className="bg-brand-green text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-33">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-brand-navy rounded-2xl p-8 text-center text-white" data-id="element-34">
          <p className="text-lg mb-2 text-white/80" data-id="element-35">
            Valor total de los bonos:
          </p>
          <div className="flex items-center justify-center gap-4 text-3xl md:text-4xl font-extrabold" data-id="element-36">
            <span className="text-white/40 line-through decoration-red-500 decoration-4" data-id="element-37">
              $35.000
            </span>
            <span className="text-brand-green" data-id="element-38">GRATIS</span>
          </div>
        </div>
      </div>
    </section>;
}